<template>
  <div id="bio-material-entity-form" v-if="entityId">
    <h2 id="bio-material-type-title" data-test="inside-vif">
      {{ pageTitle }}
    </h2>
    <h3>Are you sure?</h3>

    <b-form @submit.prevent="removeEntity">
      <div class="form-buttons">
        <v-button class="destructive" type="submit">Remove</v-button>
        <v-button class="primary ghost">
          <b-link href="/" @click="cancel">Cancel</b-link>
        </v-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import EntityFormHelper from "../../lib/EntityFormHelper.js";
import { jsonClient } from "../../lib/raftApi";
import PathMapper from "../../lib/PathMapper";
import VButton from "../raft/VButton.vue";

export default {
  name: "BioMaterialRemove",
  inject: ["isB4"],
  props: {
    materialType: {
      type: String,
      required: true,
    },
    uuid: {
      type: String,
      required: true,
    },
    groupNid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      defaultValuesReady: false,
      entity: { id: "", type: "" },
      materialTypeLabel: "",
      ogAudience: "",
      inGroup: false,
      groupEntity: {},
    };
  },
  components: {
    VButton,
  },
  methods: {
    errorEmit(error) {
      if (error.message && error.data) {
        const message = error.message;
        const data = error.data;
        this.$emit("form-error-message", { message, data });
      } else {
        this.$emit("form-error-message", { error });
      }
    },
    async removeEntity() {
      const data = EntityFormHelper.createJsonApiEntityData(
        "bio_material",
        this.materialType,
      );
      data.id = this.entity.id;
      data.attributes.operative_status = 0;
      const path = "bio_material/" + this.materialType + "/" + this.uuid;
      const queries = {};
      if (this.groupNid) {
        queries["rog-id"] = this.groupNid;
        queries["rog-type"] = "node";
      }
      const patchResponseData = await jsonClient
        .patch({ path, queries, data })
        .catch((e) => {
          this.errorEmit(e);
          this.$showNotification(
            "error",
            "Unable to remove material. Please try again.",
          );
        });
      this.$emit(
        "submit-form-data",
        `Removed ${this.entity.attributes.name}`,
        patchResponseData,
      );
      if (patchResponseData) {
        this.$showNotification(
          "success",
          `Removed ${this.entity.attributes.name}`,
        );
      }
    },
    cancel(event) {
      event.preventDefault();
      this.$emit("submit-form-data", "Canceling");
    },
  },
  computed: {
    entityId() {
      return this.entity?.id;
    },
    pageTitle: function () {
      const prefix = "Remove ";
      if (this.inGroup) {
        return (
          prefix +
          this.entity.attributes.name +
          " from " +
          this.groupTitle +
          "."
        );
      }
      return prefix + this.entity.attributes.name + " from Library.";
    },
    groupTitle: function () {
      if (this.inGroup && this.groupEntity.attributes) {
        return this.groupEntity.attributes.title;
      }
      return "";
    },
  },
  async mounted() {
    const queries = { include: "og_audience" };
    if (this.groupNid) {
      queries["rog-id"] = this.groupNid;
      queries["rog-type"] = "node";
    }
    const response = await jsonClient
      .get({ path: `/bio_material/${this.materialType}/${this.uuid}`, queries })
      .catch((e) => this.errorEmit(e));
    this.entity = response?.data;
    if (this.entity?.relationships?.og_audience?.data[0]) {
      const groupId = this.entity.relationships.og_audience.data[0].id;
      this.inGroup = true;
      for (let i = 0; i < response.included.length; i++) {
        if (response.included[i].id === groupId) {
          this.groupEntity = response.included[i];
        }
      }
    }
  },
};
</script>

<style scoped>
.form-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.form-buttons > button.primary.ghost > a {
  text-decoration: none;
}
#bio-material-entity-form {
  text-align: center;
  min-height: 6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}
#bio-material-entity-form > h2 {
  font-size: var(--font-size-100);
  line-height: normal;
}
#bio-material-entity-form > h3 {
  font-size: var(--font-size-200);
}
</style>
